import {defineStore} from 'pinia'

type GlobalSearchState = {
    searchInput: string | null,
    currentModule: string | null,
    connected: string | null,
}

export const useGlobalSearchStore = defineStore('globalSearch', {
    state: (): GlobalSearchState => ({
        searchInput: null,
        currentModule: null,
        connected: null,
    }),

    actions: {
        setCurrentModule(currentModule: string | null) {
            this.currentModule = currentModule
        },
        setSearchInput(searchInput: string | null) {
            this.searchInput = searchInput
        },
        connect(tableModule: string) {
            this.connected = tableModule
        },
        disconnect() {
            this.connected = null
        }
    },
})
